module.exports = __webpack_public_path__ + "img/reserve-pitchviewclub.83ac2f74.png";